import GuestI from '../interfaces/Guest';

const paginate = (array: GuestI[], page: number) =>
    array.slice((page - 1) * 10, page * 10);

export default paginate;
